// extracted by mini-css-extract-plugin
export default {"pricing":"planesSalut_pricing__z-+Rf","plans":"planesSalut_plans__mYD0k","plan":"planesSalut_plan__yVyTn","linkButton":"planesSalut_linkButton__0RVTs"};